import {
  EspdResponseDataType,
  type BuyerBidV2EspdCriterionDto,
  type BuyerBidV2EspdRequirementGroupDto,
} from "../../../../autogen/bff-api";

// In an ESPD the yes/no sits on the criterion's first INDICATOR requirement; `criterion.answer` is
// the buyer-facing verdict (OK / deviation / unanswered), not what the supplier answered.
export const espdIndicatorAnswer = (criterion: BuyerBidV2EspdCriterionDto): boolean | null =>
  findIndicator(criterion.responseGroups ?? []);

const findIndicator = (groups: BuyerBidV2EspdRequirementGroupDto[]): boolean | null => {
  for (const group of groups) {
    for (const instance of group.instances ?? []) {
      for (const requirement of instance.requirements ?? []) {
        if (
          requirement.responseDataType === EspdResponseDataType.Indicator &&
          requirement.value?.indicator != null
        ) {
          return requirement.value.indicator;
        }
      }
      const nested = findIndicator(instance.subGroups ?? []);
      if (nested != null) return nested;
    }
  }
  return null;
};
